/**
 * True in MSAL's sign-in popup coming back to the app: a window this app
 * opened, under the name MSAL gives its popups ("msal." and the request).
 * Kept apart from authClient.ts, so checking it doesn't load MSAL.
 */
export function isMsalPopup(win: { opener: unknown; name: string }): boolean {
  return win.opener !== null && win.opener !== undefined && win.name.startsWith("msal.");
}
